/**
 * Apple's share glyph — a box with an arrow leaving through its open top edge. Rendered
 * it inline in the iOS instructions ("Tap ⬆ at the bottom of Safari"), where naming the button is
 * useless: iOS labels it with nothing but this shape.
 *
 * Drawn here rather than added to `public/icons.svg` as the ticket sketched. That file is a leftover
 * from the project template with no consumer anywhere in the app, so a symbol in it would have
 * needed a new `<use href>` fetch — external-document `<use>` being the one form Safari has never
 * supported — to render an icon that has to inherit `currentColor` inside a line of text.
 *
 * Sized in `em` so it tracks the step text it sits in, and shifted down a hair to sit on the text's
 * optical centre rather than its baseline.
 */
export default function ShareIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 3.5v11" />
      <path d="M8.5 7 12 3.5 15.5 7" />
      <path d="M8 10.5H6.5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H16" />
    </svg>
  )
}
